import React from 'react';
import { useParams } from 'react-router-dom';
import AdminUserProfile from '../components/Admin/AdminUserProfile';

export default function AdminUserProfilePage() {
  const { id } = useParams();
  return <AdminUserProfile userId={id ?? ''} />;
}
